__turbopack_context__.v({
  "fill": "Preloader-module__EvBssa__fill",
  "logo": "Preloader-module__EvBssa__logo",
  "preloader-crawl": "Preloader-module__EvBssa__preloader-crawl",
  "root": "Preloader-module__EvBssa__root",
  "visuallyHidden": "Preloader-module__EvBssa__visuallyHidden",
});
